import React from 'react';

export interface IconDefaultAvatarProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconDefaultAvatar: React.FC<IconDefaultAvatarProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <circle cx="32" cy="32" r="32" fill={fill || "#E2E8F0"} /> <ellipse cx="32" cy="25" rx="12" ry="15" fill={fill || "#475569"} /> <path fillRule="evenodd" clipRule="evenodd" d="M54.9961 54.2526C49.1785 60.2633 41.0256 64 31.9999 64C23.2657 64 15.3488 60.5008 9.57465 54.8278C13.7175 49.0084 22.4266 45 32.4998 45C42.2376 45 50.7006 48.7459 54.9961 54.2526Z" fill={fill || "#475569"} /> <path fillRule="evenodd" clipRule="evenodd" d="M33 39.9486C39.1595 39.3134 44 32.8633 44 24.9999C44 17.131 39.1525 10.6772 32.9867 10.0499L29 25H33V39.9486Z" fill={fill || "#020617"} />  
    </svg>
  );
};

export default IconDefaultAvatar;
